import { render } from "./TheNavbarList.vue?vue&type=template&id=634d4d03&scoped=true"
import script from "./TheNavbarList.vue?vue&type=script&lang=js"
export * from "./TheNavbarList.vue?vue&type=script&lang=js"

import "./TheNavbarList.css?vue&type=style&index=0&id=634d4d03&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634d4d03"]])

export default __exports__